import { gql } from "@apollo/client";

export const PrivateSessionPage = gql`
  query GetPrivateSessionPage($pagination: PaginationInput!) {
    privateSessionPage(pagination: $pagination) {
      items {
        id
        name
        minDuration
        maxDuration
        isActive
        serviceType {
          name
        }
        revenueCategory {
          name
        }
      }
      totalRows
    }
  }
`;

export const GetPrivateSession = gql`
  query GetPrivateSession($id: String!) {
    privateSessionOne(id: $id) {
      id
      name
      description
      intervalDuration
      isTaxable
      isPostTax
      isOrg
      isRoomRequired
      isEmployeeRequired
      isOrg
      minDuration
      maxDuration
      serviceType {
        id
        name
      }
      revenueCategory {
        id
        name
      }
      organization {
        id
      }
      imageUrl
      policies {
        id
        name
      }
      rooms {
        id
        location {
          id
          name
        }
        taxRates {
          id
          organizationTaxRate {
            name
          }
        }
      }
      durations {
        id
        duration
      }
      overrides {
        id
        employee {
          id
          user {
            firstName
            lastName
          }
          locations {
            id
          }
        }
      }
    }
  }
`;

export const GetPrivateSessionsDetail = gql`
  query GetPrivateSessionsDetail($locationId: String) {
    privateSessionMany(locationId: $locationId) {
      id
      name
      isRoomRequired
      isEmployeeRequired
      minDuration
      maxDuration
      durations {
        id
        duration
      }
      rooms {
        rooms {
          id
          name
          totalCapacity
        }
      }
      overrides {
        minDuration
        maxDuration
        employee {
          id
          user {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
